import React, { useContext, useState, useEffect } from 'react';
import GenericFormModal from '../crm/shared/GenericFormModal';
import EditText from '../crm/shared/field_inputs/text/EditText';
import { HandlePatchTeacher, GetTeacherById } from './requests/TeacherRequests';
import EditTextArea from '../crm/shared/field_inputs/text/EditTextArea';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import EditSelect from '../crm/shared/field_inputs/select/EditSelect';
import { getOptionsObjectValue, getOptionsObjectValues, teacherCompensationTypeOptions } from './shared/translations';
import Checkbox from '../Checkbox';
import ExlFormModal from './shared/ExlFormModal';
import ExlEditDraft from './field_inputs/ExlEditDraft';
import { useTranslation } from 'react-i18next';
import { EDIT_TEACHER_IS_ACTIVE_LABEL, EDIT_TEACHER_LABEL, TEACHER_MODALS_COMP_TYPE_LABEL, TEACHER_MODALS_DESC_LABEL, TEACHER_MODALS_EMAIL_LABEL, TEACHER_MODALS_EMAIL_NOTI_LABEL, TEACHER_MODALS_INVALID_EMAIL_VALI, TEACHER_MODALS_NAME_LABEL, TEACHER_MODALS_NO_NAME_VALI } from '../../i18n/keyConstants';

const EditTeacher = ({ updateTeacher, submitHandler, buttonType, open, onClose }) => {

    const { dispatch: sharedDispatch } = useContext(SharedDataContext);
    const { t } = useTranslation(['teacherModals', 'editTeacher', 'shared']);

    const defaultFormValues = {
        name: updateTeacher.name,
        description: updateTeacher.description,
        email: updateTeacher.email,
        courses: updateTeacher.courses,
        isActive: updateTeacher.isActive,
        compensationType: getOptionsObjectValue(teacherCompensationTypeOptions, updateTeacher.compensationType),
        receiveEmailNotifications: updateTeacher.receiveEmailNotifications
    };

    const formComponents = [    
        {
            propName: 'name',
            label: t(TEACHER_MODALS_NAME_LABEL),
            validate: (v) => (!v || !v.length ? t(TEACHER_MODALS_NO_NAME_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'email',
            label: t(TEACHER_MODALS_EMAIL_LABEL),
            validate: (v) => (!v || !v.length ? t(TEACHER_MODALS_INVALID_EMAIL_VALI) : ''),
            component: <EditText />,
        },
        {
            propName: 'description',
            label: t(TEACHER_MODALS_DESC_LABEL),
            component: <ExlEditDraft />,
        },
        {
            propName: 'compensationType',
            label: t(TEACHER_MODALS_COMP_TYPE_LABEL),
            component: <EditSelect options={getOptionsObjectValues(teacherCompensationTypeOptions)} />
        },
        {
            propName: 'isActive',
            label: '',
            component: <Checkbox
                defaultChecked={updateTeacher.isActive === true ? true : false}
                label={t(EDIT_TEACHER_IS_ACTIVE_LABEL, {ns: 'editTeacher'})}
                usedInExl={true }
            />,
        },
        {
            propName: 'receiveEmailNotifications',
            label: '',
            component: <Checkbox usedInExl={true} defaultChecked={updateTeacher.receiveEmailNotifications} label={t(TEACHER_MODALS_EMAIL_NOTI_LABEL)} />
        }
    ];

    const populateUpdateTeacher = (teacher) => {
        updateTeacher.name = teacher.name;
        updateTeacher.description = teacher.description;
        updateTeacher.email = teacher.email;
        updateTeacher.courses = teacher.courses;
        updateTeacher.isActive = teacher.isActive;
        updateTeacher.compensationType = teacher.compensationType.value;
        updateTeacher.receiveEmailNotifications = teacher.receiveEmailNotifications;
    }

    const handleAdd = async (teacher) => {
        await populateUpdateTeacher(teacher);
        let initialTeacher = await GetTeacherById(updateTeacher.id);

        delete updateTeacher.photo;
        const response = await HandlePatchTeacher(initialTeacher, updateTeacher);
        if (response.success) {
            sharedDispatch({ type: 'SHOW_SAVED_TOAST' })
        }
        else {
            sharedDispatch({ type: 'SHOW_ERROR_TOAST' });
        }
        return response;
    };

    return (
        <ExlFormModal
            open={open}
            onClose={onClose}
            description={t(EDIT_TEACHER_LABEL, {ns: 'editTeacher'})}
            defaultFormValues={defaultFormValues}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            onSuccessiveSave={() => submitHandler()}
            isExl
        />
    );
};

export default EditTeacher;
